<template>
  <div id="Registration">
    <!-- 標題 -->
    <v-title>
      <font-awesome-icon icon="id-card-alt" />
      註冊帳號
      <v-font
        slot="etext"
        font-css="ml-3"
        font-text="Registration"
      />
    </v-title>
    <hr>
    <div class="row">
      <!-- 隱私權聲明 -->
      <div class="col-sm-6">
        <h5 class="word-bold">
          隱私權聲明
          <v-font
            font-css="spanfs"
            font-text="Privacy Policy"
          />
        </h5>
        <div style="overflow-y:scroll;height: 500px;">
          <div class="white-color">
            <PrivacyText />
          </div>
        </div>
        <div class="form-check pt-4 pb-4">
          <input
            id="Consent"
            class="form-check-input"
            type="checkbox"
            v-model="Consent"
          >
          <v-label
            for="Consent"
            class="form-check-label"
            LabText="我已同意(Approved)"
            Labbold="true"
          />
        </div>
      </div>
      <!-- 註冊欄位 -->
      <div class="col-sm-6">
        <h5 class="word-bold">
          註冊資料
          <v-font
            font-css="spanfs"
            font-text="Registration Data"
          />
        </h5>
        <form class="mb-2 white-color">
          <div class="mr-2 ml-2">
            <!-- 身分 -->
            <div class="form-group">
              <v-small />
              <v-label
                for="user_identity"
                LabText="申請身分(User identity)："
                Labbold="true"
              />
              <br>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  id="UserType1"
                  class="custom-control-input"
                  name="UserType"
                  type="radio"
                  v-model="Register.UserType"
                  value="5"
                >
                <v-label
                  for="UserType1"
                  class="custom-control-label"
                  LabText="個人(General Public)"
                />
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  id="UserType2"
                  class="custom-control-input"
                  name="UserType"
                  type="radio"
                  v-model="Register.UserType"
                  value="6"
                >
                <v-label
                  for="UserType2"
                  class="custom-control-label"
                  LabText="廠商(Vendor)"
                />
              </div>
            </div>
            <!-- 帳號ID -->
            <div class="form-group">
              <v-small />
              <v-label
                for="UserId"
                LabText="帳號(UserId)："
                Labbold="true"
              />
              <span class="font-weight-bold text-danger">*校內教職員生請勿註冊</span>
              <small class="d-block text-danger mb-2">
                <span v-if="Register.UserType === '5' || Register.UserType === '6'" class="font-weight-bold d-block text-danger mt-1">
                  （帳號需為 Email 格式）
                </span>
              </small>
              <input
                id="UserId"
                class="form-control"
                type="text"
                :placeholder="UserIdPlaceholder"
                v-model="Register.UserId"
                required
              >
            </div>
            <!-- 密碼 -->
            <div class="form-group">
              <v-small />
              <v-label
                for="UserPasswd"
                LabText="密碼(Password)："
                Labbold="true"
              />
              <input
                id="UserPasswd"
                class="form-control"
                type="password"
                placeholder="Password"
                v-model="Register.UserPasswd"
                autocomplete
                required
              >
              <v-small
                slot="small"
                SmallText="密碼長度須超過8字元，包含大小寫英文及數字。"
              />
            </div>
            <!-- 確認密碼 -->
            <div class="form-group">
              <v-small />
              <v-label
                for="ConfirmPasswd"
                LabText="確認密碼(CheckPassword)："
                Labbold="true"
              />
              <input
                id="ConfirmPasswd"
                type="password"
                class="form-control"
                placeholder="Password"
                v-model="ConfirmPasswd"
                autocomplete
                required
              >
            </div>
            <!-- 繳款人名稱 -->
            <div class="form-group">
              <v-small />
              <v-label
                for="UserName"
                LabText="繳款人名稱(UserName)："
                Labbold="true"
              />
              <input
                id="UserName"
                type="text"
                class="form-control"
                placeholder="請填寫您的大名"
                v-model="Register.UserName"
                required
              >
            </div>
            <!-- 聯絡信箱 -->
            <div class="form-group">
              <v-small />
              <v-label
                for="Email"
                LabText="聯絡信箱(Email)："
                Labbold="true"
              />
              <input
                id="Email"
                class="form-control"
                type="email"
                placeholder="請輸入聯絡信箱"
                v-model="Register.Email"
                required
              >
            </div>
            <!-- 聯絡電話 -->
            <div class="form-group">
              <v-small />
              <v-label
                for="Telephone"
                LabText="聯絡電話(Phone)："
                Labbold="true"
              />
              <input
                id="Telephone"
                class="form-control"
                type="tel"
                v-model="Register.Telephone"
                placeholder="請輸入聯絡電話"
              >
            </div>
            <!-- 聯絡地址 -->
            <div class="form-group">
              <v-label
                for="Address"
                LabText="聯絡地址(Address)："
                Labbold="true"
              />
              <input
                id="Address"
                type="text"
                class="form-control"
                placeholder="請填寫您的聯絡地址"
                v-model="Register.Address"
                required
              >
            </div>
            <!-- 公司統編 -->
            <div class="form-group">
              <v-small v-if="Register.UserType === '6'" />
              <v-label
                for="Unino"
                LabText="公司統編(Company ID Number)："
                Labbold="true"
              />
              <input
                id="Unino"
                class="form-control"
                type="tel"
                v-model="Register.Unino"
                placeholder="請填入公司統編"
              >
            </div>
            <v-button
              class="mb-2"
              btn-text="確認(Confirm)"
              btn-type="primary"
              btn-size="lg"
              @click.native="PostAccountRegister"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import PrivacyText from '@/components/Article/PrivacyText'
import vLabel from '@/components/Features/Label'
import vSmall from '@/components/Features/Small'
import { apiAccountRegister } from '../../Api/api'
export default {
  name: 'Registered',
  components: {
    PrivacyText,
    'v-label': vLabel,
    'v-small': vSmall
  },
  computed: {
    // 根據身分類型動態設定帳號placeholder
    UserIdPlaceholder () {
      if (this.Register.UserType === '5' || this.Register.UserType === '6') {
        return '請輸入Email'
      } else {
        return '請輸入Email'
      }
    }
  },
  data () {
    return {
      ConfirmPasswd: '',
      Consent: '',
      Register: {
        APIVer: '0',
        ClientIP: '',
        UserType: '',
        UserId: '',
        UserPasswd: '',
        UserName: '',
        Email: '',
        Telephone: '',
        Address: '',
        Unino: ''
      },
      Registry: {}
    }
  },
  created () {
    this.getClientip()
  },
  methods: {
    getClientip () { // 取得使用端IP
      const Logins = this.Register
      $.getJSON('https://api.ipify.org?format=jsonp&callback=?', function (data) {
        Logins['ClientIP'] = data.ip
      })
    },
    PostAccountRegister () {
      const vm = this
      const Checkpw = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,20})*$/
      // Email 正規表達式
      // const CheckEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      // 判斷隱私權
      if (vm.Consent) {
        // 判斷欄位空值
        if (vm.Register.UserType !== '' && vm.Register.UserId !== '' &&
            vm.Register.UserPasswd !== '' && vm.Register.UserName !== '' &&
            vm.Register.Email !== '' && vm.Register.Telephone !== '' &&
            vm.Register.ConfirmPasswd !== '') {
          // if (vm.Register.UserType === '5') {
          //   if (!CheckEmail.test(vm.Register.UserId)) {
          //     vm.ErrorModal('個人身分帳號必須為 Email 格式（需包含@）')
          //     return false
          //   }
          // }
          if (vm.Register.UserType === '6') {
            if (vm.Register.Unino === '') {
              vm.ErrorModal('*必填欄位請填選。')
              return false
            }
          }
          // 判斷密碼與確認密碼一致性
          if (!Checkpw.test(vm.Register.UserPasswd)) {
            vm.ErrorModal('密碼須超過8字元，包含大小寫英文及數字。')
            return false
          }
          if (vm.Register.UserPasswd === vm.ConfirmPasswd) {
            // 呼叫API
            apiAccountRegister(vm.Register).then(
              res => {
                if (res !== undefined) {
                  // 保存到 local Storage
                  // 將 data 轉為字串型態再保存
                  vm.Registry.RegToken = res.RegToken
                  vm.Registry.UserId = res.UserId
                  vm.Registry.APIVer = vm.Register.APIVer
                  vm.Registry.ClientIP = vm.Register.ClientIP
                  const RegistryData = JSON.stringify(vm.Registry)
                  localStorage.setItem('Registry', RegistryData)
                  // 彈跳成功訊息，導向news葉面
                  vm.$bus.$emit('Modals', '註冊成功，請至信箱啟動帳號認證')
                  $('#CheckOk').modal('show')
                  vm.$router.push({ name: 'Home_News' })
                } else {
                  $('#CheckError').modal('show')
                }
              }
            )
          } else {
            vm.ErrorModal('密碼與確認密碼不一致。')
          }
        } else {
          vm.ErrorModal('*必填欄位請填選。')
        }
      } else {
        vm.ErrorModal('請勾選同意隱私權聲明。')
      }
    },
    ErrorModal (data) { // 錯誤彈跳視窗
      this.$bus.$emit('Modals', data)
      $('#CheckError').modal('show')
    }
  }
}
</script>
